import moment from 'moment';
import { defaultGet } from '@4beefopag/4bee-fopag-core/dist/services';

export const buscarParametrizacao = async (idFolha, vigencia) => {
  if (idFolha !== null && idFolha !== undefined && vigencia !== null && vigencia !== undefined) {
    const res = await defaultGet(
      {
        idFolha,
        vigencia: moment(vigencia).format('MM/YYYY'),
      },
      '/parametrizacao'
    );

    return res;
  }

  return {};
};

export const buscarUltimaParametrizacaoCriada = async (idFolha) => {
  if (idFolha) {
    const res = await defaultGet({}, `/parametrizacao/folha/${idFolha}/ultima`);
    return res;
  }
  return {};
};

export const buscarUltimaParametrizacao = async (idFolha, vigencia) => {
  if (idFolha !== null && idFolha !== undefined && vigencia !== null && vigencia !== undefined) {
    const res = await defaultGet(
      {
        idFolha,
        vigencia: moment(vigencia).format('MM/YYYY'),
      },
      '/parametrizacao/buscarUltimaParametrizacao'
    );

    return res;
  }

  return {};
};
